(function () {
  var labels = new WeakMap();
  var language = (document.documentElement.lang || 'fr').toLowerCase();
  var unavailable = language.indexOf('pt') === 0 ? 'indisponível' : language.indexOf('de') === 0 ? 'nicht verfügbar' : language.indexOf('en') === 0 ? 'unavailable' : 'indisponible';
  function sync(btn) {
    var off = btn.classList.contains('is-unavailable');
    if (!labels.has(btn)) labels.set(btn, btn.getAttribute('aria-label') || btn.title || btn.textContent.trim());
    btn.setAttribute('aria-disabled', off ? 'true' : 'false');
    btn.setAttribute('aria-label', labels.get(btn) + (off ? ' — ' + unavailable : ''));
  }
  function bind(root) {
    (root || document).querySelectorAll('[data-soniel-picker]').forEach(function (picker) {
      if (picker.dataset.a11y === '1') return;
      picker.dataset.a11y = '1';
      picker.querySelectorAll('[data-option-btn]').forEach(sync);
      new MutationObserver(function (muts) {
        muts.forEach(function (m) {
          if (m.target && m.target.hasAttribute && m.target.hasAttribute('data-option-btn')) sync(m.target);
        });
      }).observe(picker, { subtree: true, attributes: true, attributeFilter: ['class'] });
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { bind(document); });
  else bind(document);
})();
